/**
 * Holdings Page
 */

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHoldings } from '../redux/slices/portfolioSlice';

const Holdings = () => {
  const dispatch = useDispatch();
  const { holdings, loading } = useSelector((state) => state.portfolio);

  useEffect(() => {
    dispatch(fetchHoldings('CNC'));
  }, [dispatch]);

  const totalValue = holdings.reduce((sum, holding) => {
    return sum + (holding.dpQuantity * holding.averageTradedPrice);
  }, 0);

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold text-gray-800">Holdings</h1>

      <div className="card">
        <div className="mb-4">
          <h3 className="text-sm font-medium text-gray-600">Total Portfolio Value</h3>
          <p className="text-3xl font-bold text-primary-600">
            ₹{totalValue.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
          </p>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <p className="text-center py-8 text-gray-500">Loading holdings...</p>
        ) : holdings.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="table-auto w-full">
              <thead>
                <tr>
                  <th>Symbol</th>
                  <th>ISIN</th>
                  <th>Quantity</th>
                  <th>Avg Price</th>
                  <th>Current Value</th>
                  <th>P&L</th>
                </tr>
              </thead>
              <tbody>
                {holdings.map((holding, idx) => {
                  const currentValue = holding.dpQuantity * holding.averageTradedPrice;
                  const invested = holding.dpQuantity * holding.averageTradedPrice;
                  const pnl = currentValue - invested;
                  const pnlPercent = (pnl / invested) * 100;

                  return (
                    <tr key={idx}>
                      <td className="font-medium">{holding.formattedInstrumentName}</td>
                      <td className="text-sm text-gray-600">{holding.isin}</td>
                      <td>{holding.dpQuantity}</td>
                      <td>₹{holding.averageTradedPrice?.toFixed(2)}</td>
                      <td>₹{currentValue.toFixed(2)}</td>
                      <td className={pnl >= 0 ? 'text-success' : 'text-danger'}>
                        ₹{pnl.toFixed(2)} ({pnlPercent.toFixed(2)}%)
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-center py-8 text-gray-500">No holdings found</p>
        )}
      </div>
    </div>
  );
};

export default Holdings;
